export default __webpack_public_path__ + "static/media/gwt.7d277170.svg";